import { useCallback } from 'react';
import { throttle } from 'throttle-debounce';

import {
    DragCallbackParams,
    useDrag as useDragBase,
} from '@/scenarios/legacy-player/components/PlayerSkin/parts/Slider/hooks/useDrag';
import { useVolume } from '@/scenarios/legacy-player/hooks/useVolume';
import { MAX_VOLUME } from '@/scenarios/legacy-player/constants/volume';

const VOLUME_CHANGE_THROTTLE = 20;

interface Params {
    sliderHeight?: number;
    containerBottomPadding?: number;
}

export const useVolumeDrag = ({ sliderHeight = 0, containerBottomPadding = 0 }: Params) => {
    const { setVolume } = useVolume();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onDrag = useCallback(
        throttle(VOLUME_CHANGE_THROTTLE, ({ clientY }: DragCallbackParams) => {
            setVolume(Math.trunc(((containerBottomPadding - clientY) / sliderHeight) * MAX_VOLUME));
        }),
        [containerBottomPadding, setVolume, sliderHeight]
    );

    const { dragging: isDragged, onMouseDown } = useDragBase({
        onDrag,
    });

    return {
        isDragged,
        onDragStart: onMouseDown,
    };
};
